import React from 'react';
import { dropdownMaxOptions, dropdownOptionHeight, dropdownSmallOptionHeight, dropdownWithoutOptionsMinHeight } from 'src/constants/styles';

export const getDurations = (options: { index: number; max: number; diff: number }): number => {
  if (options.index > options.max) return options.max * options.diff;
  return options.index * options.diff;
};

export const getDropdownHeights = (
  listLength: number,
  isSearchable?: boolean,
  maxVisibleOptions?: number,
  smallOptions?: boolean
): React.CSSProperties => {
  const optionHeight: number = smallOptions ? dropdownSmallOptionHeight : dropdownOptionHeight;
  const styles: React.CSSProperties = {
    height: isSearchable ? (listLength + 1) * optionHeight : listLength * optionHeight,
  };
  const halfHeight: number = optionHeight / 2;

  if (maxVisibleOptions) {
    styles.maxHeight = optionHeight * (maxVisibleOptions || dropdownMaxOptions) + halfHeight;
  } else {
    styles.maxHeight = (isSearchable ? dropdownOptionHeight * dropdownMaxOptions : dropdownOptionHeight * (dropdownMaxOptions - 1)) + halfHeight;
  }

  if (isSearchable) {
    styles.minHeight = listLength ? optionHeight * 2 : optionHeight + dropdownWithoutOptionsMinHeight;
  } else {
    styles.minHeight = listLength ? optionHeight : dropdownWithoutOptionsMinHeight;
  }

  return styles;
};
